/** Soft info wash for link/photo assisted-entry badges. */
export const softInfoAssistedIconBadgeSx = {
  backgroundImage: "linear-gradient(145deg, #F0F5FF 0%, #E4ECFA 100%)",
  color: "info.main",
} as const;

/** Deep indigo → sky blue stops (Generate with AI badge / compact AI chip icon). */
export const indigoSkyGradientStops = {
  indigo: "#4C3FB8",
  blue: "#3B82F6",
  sky: "#38BDF8",
} as const;

/** Deep indigo → sky blue badge fill. */
export const indigoSkyAssistedIconBadgeSx = {
  backgroundImage: `linear-gradient(135deg, ${indigoSkyGradientStops.indigo} 0%, ${indigoSkyGradientStops.blue} 55%, ${indigoSkyGradientStops.sky} 100%)`,
  color: "common.white",
} as const;

export type AssistedIconBadgeVariant = "softInfo" | "indigoSky";

export const assistedIconBadgeSx = (variant: AssistedIconBadgeVariant) =>
  variant === "indigoSky" ? indigoSkyAssistedIconBadgeSx : softInfoAssistedIconBadgeSx;
